import { Injectable } from '@angular/core';
import { LiteratureGlobalConfigService } from '@literature/services/literature-global-config.service';
import {
  BaseFilter,
  CustomLiteratureFilter,
  FundFilterService,
  ListingLiteratureFilter,
} from '@products/fund-listing/services/fund-filter.service';
import { FilterStateManagerService } from '@shared/services/filter-state-manager.service';
import {
  FilterType,
  LiteratureListingConfiguration,
  OptionWithCount,
} from '@types';
@Injectable({
  providedIn: 'root',
})
export class LiteratureFilterStateManagerService extends FilterStateManagerService {
  literaturePageConfig: LiteratureListingConfiguration;
  constructor(
    filterService: FundFilterService,
    private literatureConfig: LiteratureGlobalConfigService
  ) {
    super(filterService);
  }
  /**
   * Create filters based on response and configuration from Bloomreach
   */
  createFilters(): void {
    this.literaturePageConfig = this.literatureConfig.getLiteratureListingConfig();
    const pageType = this.literaturePageConfig?.pageTypeName;
    const primaryFilters:
      | CustomLiteratureFilter[]
      | ListingLiteratureFilter[] = this.literaturePageConfig?.primaryFilters.map(
      (key) => {
        if (pageType === 'regulatory-fund-documents') {
          return CustomLiteratureFilter[key];
        } else {
          return ListingLiteratureFilter[key];
        }
      }
    );
    const additionalFilters:
      | CustomLiteratureFilter[]
      | ListingLiteratureFilter[] = this.literaturePageConfig?.additionalFilters.map(
      (key) => {
        if (pageType === 'regulatory-fund-documents') {
          return CustomLiteratureFilter[key];
        } else {
          return ListingLiteratureFilter[key];
        }
      }
    );
    this.formatProductDataByFilters([...primaryFilters, ...additionalFilters]);
    primaryFilters.forEach((filterListItem: BaseFilter) => {
      this.state.primaryFilters.push(this.createFilterType(filterListItem));
    });
    additionalFilters.forEach((filterListItem: BaseFilter) => {
      this.state.additionalFilters.push(this.createFilterType(filterListItem));
    });
    // TODO: pick config from right path i.e., decorated config.
    if (pageType !== 'regulatory-fund-documents') {
      this.state.clientUseFilter = {
        label: ListingLiteratureFilter.CLIENT_USE.key,
        type: ListingLiteratureFilter.CLIENT_USE,
        selected: [],
      };
    }
    if (pageType === 'regulatory-fund-documents') {
      this.state.searchKeyword = {
        label: CustomLiteratureFilter.SEARCH_KEYWORD.key,
        type: CustomLiteratureFilter.SEARCH_KEYWORD,
      };
    } else {
      this.state.searchKeyword = {
        label: ListingLiteratureFilter.SEARCH_KEYWORD.key,
        type: ListingLiteratureFilter.SEARCH_KEYWORD,
      };
    }
  }
  /**
   * Return filter type object against inputs from decorated config & feed.
   * @param filterListItem various filter type from decorated config, like in - primary/additional
   */
  protected createFilterType(filterListItem: BaseFilter): FilterType {
    if ('LANGUAGE' === filterListItem.key) {
      const valuesWithCount = this.sortFilterValues(filterListItem);
      const languageValuesWithClient: OptionWithCount[] = [];

      valuesWithCount.map(([value, count]) => {
        const language = value.split('-')[0];
        const index = languageValuesWithClient.findIndex(
          (e) => e.value === language
        );

        if (index >= 0) {
          languageValuesWithClient[index].count += count;
        } else {
          languageValuesWithClient.push({
            value: language,
            count,
          });
        }
      });

      return {
        label: filterListItem.key,
        options: languageValuesWithClient,
        selected: [],
        type: filterListItem,
      };
    } else {
      return super.createFilterType(filterListItem);
    }
  }

  /**
   * provide custom sorting based on docTypes coming from siteConfig.
   * custom sorting only works for document_type filter
   * @param filterListItem various filter type from decorated config, like in - primary/additional
   */
  protected sortFilterValues(filterListItem: BaseFilter): [string, number][] {
    if ('DOCUMENT_TYPE' === filterListItem.key) {
      const docTypeList = this.literaturePageConfig?.documentTypeDisplay;
      return Array.from(this.filtersWithValues.get(filterListItem)).sort(
        ([item, count], [item1, count1]) => {
          const indexDoc1 = docTypeList.indexOf(item);
          const indexDoc2 = docTypeList.indexOf(item1);
          return indexDoc1 - indexDoc2;
        }
      );
    } else if ('DATE' === filterListItem.key) {
      return super.sortFilterValues(filterListItem, true);
    } else {
      return super.sortFilterValues(filterListItem);
    }
  }
  /**
   * Filter by client use value.
   * @param value input text
   */
  filterByClientUse(value: string) {
    if (value?.trim() === '' || value?.trim() === 'No') {
      this.state.clientUseFilter.selected = [];
    } else {
      this.state.clientUseFilter.selected = [value.trim()];
    }
    this.filter();
  }
  mapPreFilterState(selectedPreFilter: string) {
    this.selectedPreFilter = selectedPreFilter;
    super.mapState();
  }
}
